export enum CartType {
    Primary = 1,
    Saved = 2,
}
